import { render, staticRenderFns } from "./accountsOtherAdd.vue?vue&type=template&id=a8a2b1b0&scoped=true&"
import script from "./accountsOtherAdd.vue?vue&type=script&lang=js&"
export * from "./accountsOtherAdd.vue?vue&type=script&lang=js&"
import style0 from "./accountsOtherAdd.vue?vue&type=style&index=0&id=a8a2b1b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a2b1b0",
  null
  
)

export default component.exports